import React from 'react';
import { BENEFITS_SPONSORSHIP_URL, BENEFITS_URL } from 'src/utilities/envConfig';
import { TextLink, Typography } from '@guildeducationinc/recess';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import styles from './HeroInfo.module.scss';

export const HeroInfo: React.FC = () => {
	const { userFromIdToken: user } = useMemberExperienceAuth();
	const employer = user?.employer || '';

	return (
		<div className={styles.infoContainer} data-title='Info' id='info'>
			<div className={styles.infoBoxContainer}>
				<div className={styles.infoBox} data-testid='info-1'>
					<Typography variant='h2'>Who is it for?</Typography>
					<Typography className={styles.infoText} variant='body1'>
						The Direct Payment Program is a great option for students looking for a program that is
						not offered through the{' '}
						<TextLink href={BENEFITS_URL} target='_blank'>
							{employer === 'Guild' ? null : `${employer} `}Guild Certified Network
						</TextLink>
						.
					</Typography>
				</div>
				<div className={styles.infoBox} data-testid='info-2'>
					<Typography variant='h2'>How does it work?</Typography>
					<Typography className={styles.infoText} variant='body1'>
						Once you are accepted at a Direct Payment Program school, you can apply for funding.
						Your employer will pay a{' '}
						<TextLink href={BENEFITS_SPONSORSHIP_URL} target='_blank'>
							set amount
						</TextLink>{' '}
						of tuition and fees directly to the school.
					</Typography>
				</div>
				<div className={styles.infoBox} data-testid='info-3'>
					<Typography variant='h2'>What should I expect?</Typography>
					<Typography className={styles.infoText} variant='body1'>
						Once your application for funding is approved, you&apos;ll receive a Sponsorship Letter
						to send to your school. This lets the school know the amount your employer will pay.
					</Typography>
				</div>
			</div>
			<div>
				<Typography className={styles.infoFooter} variant='body1'>
					Learn more about your{' '}
					<TextLink href={BENEFITS_SPONSORSHIP_URL} target='_blank'>
						funding options and see step-by-step instructions
					</TextLink>
					.
				</Typography>
			</div>
		</div>
	);
};
